<template>
  <div ref="el">
    <router-view id="router-view" />
    <FloatButtonGroup v-if="showFloatButton" />
  </div>
</template>

<script setup>
import HomeHeader from '@/components/Home/HomeHeader.vue'
import Navbar from '@/components/Navbar/Navbar.vue'
import Header from '@/components/Headbar/Header.vue'
// import FixedPopup from '@/components/Fixed/FixedPopup/FixedPopup.vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import FloatButtonGroup from '@/components/FloatButtonGroup.vue'

import { useWindowScroll, useElementSize } from '@vueuse/core'

const { y } = useWindowScroll()
const el = ref(null)
const { height } = useElementSize(el)
const showFloatButton = computed(
  () => y.value > 72 && y.value < height.value * 0.6,
)

const route = useRoute()
const page = computed(() => route.name)
const blackList = [
  'Blog',
  'Article',
  'TagArticle',
  'Policy',
  'ArticleTest',
  'Home',
  'NotFound',
  'Tutorial',
  'TutorialList',
  'TutorialContent',
]

onMounted(() => {
  const app = window.document.getElementById('app')
  app.style.paddingBottom = '0px'
})
</script>

<style scoped lang="postcss"></style>
